import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss'],
})
export class ImageComponent implements OnInit {

    static componentName = 'ImageComponent';
    @Input()imgSource: String;
    @Input()fluid: Boolean;

    ngOnInit() {
        // Fluid image parallax effect

        setTimeout(() => {
            if (typeof window !== 'undefined') {
                const imageContainer = document.querySelector('.image.fluid > div.image');
                const imageOffsetTop = imageContainer
                    .getBoundingClientRect()
                    .top + window.pageYOffset - imageContainer.ownerDocument.documentElement.clientTop;

                let imageScroll = -400;
                let multiplier = 4;
                if(window.innerWidth <= 767) {
                    imageScroll = -100;
                    multiplier = 1;
                }
                let startYPos = 0;
                window.onscroll = () => {
                    if (window.scrollY >= (imageOffsetTop - window.innerHeight)
                        && window.scrollY <= (imageOffsetTop + imageContainer.scrollHeight)) {
                        if (startYPos === 0) {
                            startYPos = window.scrollY;
                        }
                        // The image is in view
                        const percentScrolled = (window.scrollY - startYPos) / (imageContainer.scrollHeight + window.innerHeight);
                        const imageEl = document.querySelector('.image.fluid > div.image > img');
                        imageEl.setAttribute('style', 'transform: translate3d(' + (imageScroll + ((percentScrolled * 100) * multiplier)) + 'px, 0px, 0px)');
                    }
                };
            }
        }, 1000);
    }

}



// WEBPACK FOOTER //
// E:/MBP/BloomyNG/src/app/image/image.component.ts